var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title_wrapper fl clearfix"},[_c('div',{staticClass:"title-line fl clearfix"},[_c('span',{staticClass:"fl"},[_vm._v(_vm._s(_vm.titleText))]),_vm._v(" "),_c('div',{staticClass:"fl line"})]),_vm._v(" "),_c('div',{staticClass:"introduce_text fl"},[_vm._v("\n    推荐行业相关资讯\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9dbee66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = null
// module chunks = 